import { supabase } from '../supabase/client';
import { createLink, removeLink } from '../entityLinks';

// Kontakte einer Liegenschaft (Hausmeister, Ansprechpartner, Versorger …). Gespeichert als
// entity_links objekt → kontakt mit link_type 'kontakt'; die Rolle steht in `rolle`.
// Gelesen über die vorhandene View v_objekt_kontakte, die Kontakt- UND Eigentümer-Ziele
// auflöst (dieselbe Quelle nutzt die Einheiten-Detailseite).

export interface ObjektKontaktZeile {
  link_id: string;
  objekt_id: string;
  target_id: string;
  _source: 'kontakt' | 'eigentuemer' | string;
  funktion: string | null;
  ist_primaer: boolean | null;
  vorname: string | null;
  nachname: string | null;
  firma_name: string | null;
  email: string | null;
  telefon: string | null;
  festnetz?: string | null;
  handynummer?: string | null;
  typ?: string | null;
}

/** Firmenname hat Vorrang, sonst Vor-/Nachname. */
export function kontaktName(z: Pick<ObjektKontaktZeile, 'vorname' | 'nachname' | 'firma_name'>): string {
  const firma = (z.firma_name || '').trim();
  if (firma) return firma;
  const person = [z.vorname, z.nachname].map((s) => (s || '').trim()).filter(Boolean).join(' ');
  return person || '—';
}

/** Erste brauchbare Erreichbarkeit: Telefon vor Handy vor Festnetz, sonst E-Mail. */
export function kontaktErreichbarkeit(z: Pick<ObjektKontaktZeile, 'telefon' | 'handynummer' | 'festnetz' | 'email'>): string {
  const kandidaten = [z.telefon, z.handynummer, z.festnetz, z.email];
  return kandidaten.map((s) => (s || '').trim()).find(Boolean) || '–';
}

export async function ladeObjektKontakte(objektId: string): Promise<ObjektKontaktZeile[]> {
  const { data, error } = await supabase
    .from('v_objekt_kontakte')
    .select('link_id, objekt_id, target_id, _source, funktion, ist_primaer, vorname, nachname, firma_name, email, telefon, festnetz, handynummer, typ')
    .eq('objekt_id', objektId);
  if (error) { console.warn('Objekt-Kontakte nicht ladbar:', error.message); return []; }
  return (data || []) as ObjektKontaktZeile[];
}

export async function verknuepfeObjektKontakt(objektId: string, kontaktId: string, funktion: string): Promise<void> {
  const { error } = await createLink({
    sourceType: 'objekt', sourceId: objektId,
    targetType: 'kontakt', targetId: kontaktId,
    linkType: 'kontakt', rolle: funktion.trim() || undefined,
  });
  if (error) throw new Error(error.message);
}

export async function loeseObjektKontakt(linkId: string): Promise<void> {
  const { error } = await removeLink(linkId);
  if (error) throw new Error(error.message);
}
